import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import  { API } from "../../helper/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPlus } from "react-icons/fa";

const AddtStoreData = () => {
    const navigate = useNavigate();
    const goToAddStore = (corporatestorenbr) => {
      navigate("/addstores", {
        state: { corporatestorenbr }, // data passed via POST-like behavior
      });
    };

    const [StoreNbr, setStoreNbr] = useState("");
    const [StoreShortName, setStoreShortName] = useState("");
    const [StoreStatus, setStoreStatus] = useState("");
    const [StoreCity, setStoreCity] = useState("");
    const [StoreState, setStoreState] = useState("");
    const [sourceTenantId, setsourceTenantId] = useState("");

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        // Validate required fields
                if (
                  !StoreNbr ||
                  !StoreShortName ||
                  !StoreStatus ||
                  !StoreState ||
                  !StoreCity ||
                  !sourceTenantId
                ) {
                  //alert("Please fill in all required fields.");
                  toast.error("Please fill in all required fields.", {
                              position: "top-center",
                              autoClose: false,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              theme: "colored",
                              className: "login-toast",
                            });
                  return;
                }
              
                // Debug logs
                console.log("StoreNbr #:", StoreNbr);
                console.log("StoreShortName:", StoreShortName);
                console.log("StoreStatus:", StoreStatus);
                console.log("StoreState:", StoreState);
                console.log("StoreCity:", StoreCity);
                console.log("SourceTenantId:", sourceTenantId);

    // Prepare form data
            const formData = {
              type: "inserttstoredata",
              StoreNbr: StoreNbr,
              StoreShortName: StoreShortName,
              StoreStatus: StoreStatus,
              StoreCity: StoreCity,
              StoreState: StoreState, 
              sourceTenantId: sourceTenantId
            };
            console.log("Formdata", formData);
            try {
              const result = await API.storeSetting("inserttstoredata", formData);
              if (result.error) {
                //alert(result.message || "Not Inserted");
                toast.error(result.message || "Not Inserted", {
                            position: "top-center",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored",
                            className: "login-toast",
                          });navigate("/addstores");
              } else {
                //alert(result.message || "Inserted Successfully!");
                toast.success(result.message || "Inserted Successfully!", {
                            position: "top-center",
                            autoClose: false,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "colored",
                            className: "login-toast",
                          });
                navigate("/listtstoredata");
              }
            } catch (err) {
              console.error("Submission failed:", err);
              //alert("Error submitting form.");
              toast.error("Error submitting form.", {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
                className: "login-toast",
              });
            }
          };

          const containerStyles = {
    padding: "30px",
    width: "60%",
    borderRadius: "8px",
    // backgroundColor: '#f8f9fa',
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Light shadow for a floating effect
  };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
     marginBottom: '15px',
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };

  const dropdownStyles = {
    position: "absolute",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    width: "90%",
    zIndex: "1000",
    maxHeight: "200px",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    padding: "10px",
  };

  const checkboxStyles = {
    margin: "5px 0",
  };

  const permissionLabelStyles = {
    marginLeft: "5px",
  };
  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "-8px",
    marginBottom: "10px",
  };

  return (
      <div className="container-fluid page-body-wrapper">
        {/* Add the Shake Keyframe Animation */}
        <style>
          {`
            @keyframes shake {
              0% { transform: translateX(0); }
              25% { transform: translateX(-5px); }
              50% { transform: translateX(5px); }
              75% { transform: translateX(-5px); }
              100% { transform: translateX(0); }
            }
  
            .shake {
              animation: shake 0.5s ease-in-out;
            }
              
          `}
        </style>
        <div className="main-panel" >
          <div className="content-wrapper" style={{ paddingBottom: "80px" }}>
            <ToastContainer
                        position="top-center"
                        autoClose={500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
            <div className="container mainbody1" style={{ maxWidth: '1900px' }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <h2 className="form-header">Create tStoreData</h2>
                          <Link to="/liststores" className="btn btn-success btn-sm"><i class="mdi mdi-arrow-right"></i>Store List</Link>
                        </div>
                <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
                    {/* Role label in a separate row */}
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="StoreNbr" style={labelStyles}>
                                CorporateNbr<span className="requireds">*</span>
                            </label>
                            <input
                                id="StoreNbr"
                                type="text"
                                placeholder="Enter corporate number"
                                value={StoreNbr}
                                onChange={(e) => setStoreNbr(e.target.value)}
                                
                                style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                                }}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="StoreShortName" style={labelStyles}>
                            Store Short Name<span className="requireds">*</span>
                            </label>
                            <input
                            id="StoreShortName"
                            type="text"
                            placeholder="Enter StoreShortName"
                            value={StoreShortName}
                            onChange={(e) => setStoreShortName(e.target.value)}
                            
                            style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                            }}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="StoreStatus" style={labelStyles}>
                                Store Status<span className="requireds">*</span>
                            </label>
                            <input
                                id="StoreStatus"
                                type="text"
                                placeholder="Enter StoreStatus"
                                value={StoreStatus}
                                onChange={(e) => setStoreStatus(e.target.value)}
                                
                                style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                                }}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="StoreCity" style={labelStyles}>
                            Store City<span className="requireds">*</span>
                            </label>
                            <input
                            id="StoreCity"
                            type="text"
                            placeholder="Enter Store City"
                            value={StoreCity}
                            onChange={(e) => setStoreCity(e.target.value)}
                            
                            style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                            }}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="StoreState" style={labelStyles}>
                                Store State<span className="requireds">*</span>
                            </label>
                            <input
                                id="StoreState"
                                type="text"
                                placeholder="Enter Store State"
                                value={StoreState}
                                onChange={(e) => setStoreState(e.target.value)}
                                
                                style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                                }}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="sourceTenantId" style={labelStyles}>
                            Source TenantId<span className="requireds">*</span>
                            </label>
                            <input
                            id="sourceTenantId"
                            type="text"
                            placeholder="Enter Source TenantId"
                            value={sourceTenantId}
                            onChange={(e) => setsourceTenantId(e.target.value)}
                            
                            style={{
                                width: "100%",
                                padding: "8px",
                                marginBottom: "15px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                fontSize: "14px",
                                height: "47px",
                            }}
                            />
                        </div>
                    </div>

                    {/* Submit button */}
                    <div style={{ display: "flex", gap: "5px" }}>
                        <button
                            type="submit"
                            className="submit-btn"
                            style={{
                                padding: "10px 20px",
                                border: "none",
                                backgroundColor: "#008000",
                                color: "#fff",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "16px",
                            }}
                            //onClick={() => navigate("/users")}
                            >
                            Submit
                        </button>
                    </div><br></br>

                </form>
                </div>
                </div>
                </div>
                </div>
                );
};
export default AddtStoreData;